import { t } from '@lingui/macro';

import Panel from '../../page-framework/panel/PanelDecorator';
import PanelActions from '../../page-framework/panel/PanelActions';
import {
    PANEL_CATEGORIES,
    COLUMN_CHART_PANEL_PREVIEW_IMAGE,
    PANEL_PRIORITIES,
} from '../../page-framework/panel/PanelRegistry';
import { panelPropTypes, panelPropDefaults } from '../../page-framework/panel/PanelPropTypes';
import { useId } from '../../page-framework/panel/Panel';
import usePanelDataService from '../../../services/PanelDataService';
import {
    LINEAR,
    LOGARITHMIC,
    useSyslogChartConfig,
    useSyslogDataSource,
    SyslogChart,
} from '../../charts/syslog-chart/SyslogChart';
import ChartTypeForm from '../../charts/ipm/ChartTypeForm';
import { timeRangeFilterId, useVirtualMachine, virtualMachineFilterId } from '../../filters';
import useChartDisplayType from '../../../utilities/UseChartDisplayType';

const title = t`Virtual Machine Syslog Events`;

const selections = [
    { value: LINEAR, label: t`Linear` },
    { value: LOGARITHMIC, label: t`Logarithmic` },
];

function VirtualMachineSyslogPanel() {
    const id = useId();
    const vm = useVirtualMachine();
    const pageStateKey = `${id}-ChartType`;
    const [chartDisplayType, setChartDisplayType] = useChartDisplayType(pageStateKey, LINEAR);
    const chartConfig = useSyslogChartConfig(chartDisplayType);
    const dataSource = useSyslogDataSource('server');
    const data = usePanelDataService(dataSource);
    const chartData = data?.data?.[0];

    if (!data) return null;

    return (
        <>
            <PanelActions>
                <ChartTypeForm value={chartDisplayType} onChangeType={setChartDisplayType} selections={selections} />
            </PanelActions>
            <SyslogChart chartDef={chartConfig} data={chartData} entity={vm} />
        </>
    );
}

VirtualMachineSyslogPanel.propTypes = panelPropTypes;

VirtualMachineSyslogPanel.defaultProps = {
    ...panelPropDefaults,
    title,
    contentHeight: 175,
    minContentHeight: 175,
};

export default Panel({
    typeAlias: 'VmwareVmSyslogTrend',
    catalogEntry: {
        category: PANEL_CATEGORIES.VIRTUAL_MACHINE,
        priority: PANEL_PRIORITIES.CHART,
        title,
        description: t`Syslog event counts trend for a selected virtual machine (VM)`,
        previewImage: COLUMN_CHART_PANEL_PREVIEW_IMAGE,
        ipm: true,
    },
    filters: {
        required: [timeRangeFilterId, virtualMachineFilterId],
        optional: [],
    },
})(VirtualMachineSyslogPanel);
